export const API_KEY = "703753488895e2aa0c9ba49a92068773";
export const TMBD_BASE_URL = "https://api.themoviedb.org/3";